import React from 'react';
import { vacancyApi } from '@cp/entities/vacancy';
import { ContentSkeleton } from '@cp/ds/src/components/contentSkeleton';
import { Stack } from '@cp/ds/src/components/stack';
import { SxProps } from '@cp/ds';
import { Typography } from '@cp/ds/src/components/typography';
import { ApiServerEntityIDType } from '@cp/utils/apiServer/types';
import { VacancyCard } from 'src/entities/vacancy';

export interface VacancyListProps {
  onItemClick?: (id: ApiServerEntityIDType) => void;
  sx?: SxProps;
}

const cardSx: SxProps = {
  backgroundColor: 'white',
};

export const VacancyList: React.FC<VacancyListProps> = ({ onItemClick, sx }) => {
  const { data, isLoading } = vacancyApi.endpoints.getVacancyListForCurrectClient.useQuery();

  if (isLoading) {
    return <ContentSkeleton blocks={2} />;
  }

  if (!data) {
    return null;
  }

  return (
    <Stack direction="column" gap={2} sx={sx}>
      {data?.length ? (
        data.map((item) => <VacancyCard data={item} key={item.id} onClick={() => onItemClick?.(item.id)} sx={cardSx} width="100%" />)
      ) : (
        <Typography component="div" sx={{ width: 1, pt: 4, pb: 10, textAlign: 'center', color: 'gray' }} variant="body">
          Нет объявлений
        </Typography>
      )}
    </Stack>
  );
};
